import { render, staticRenderFns } from "./OutrosPage.vue?vue&type=template&id=1324ad42&"
import script from "./OutrosPage.vue?vue&type=script&lang=js&"
export * from "./OutrosPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports